
import Group from 'vux/src/components/group/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import { common, commonApi } from '@/common/index';
import { mapState, mapMutations } from 'vuex';
import BScroll from 'better-scroll';
import { myMsgTabOptions, resetTextBylangKey } from '../../../libs/options.js'
import loadMore from '@/common/components/load-more/index.vue'
import { parseTime } from '@/common/utils/Date.js'

export default {
name: 'myEmail',
components: { Checker, CheckerItem, Badge, InlineLoading, XButton, loadMore },
data() {
return {
currentValue: 0,
pageNo: 1,
pageSize: 10,
step: 10,
publishInfo: [],//消息
total: null,
checkedLists: [],
allChecked: false,//全选
openItemId: null,//展开的信息
finish: null
}
},
computed: {
...mapState({
UUID: state => state.UUID,
inEmailNum: state => state.inEmailNum
}),
tabLists() {
return resetTextBylangKey(myMsgTabOptions, this.$t('mine').stationLetter.myMessageTab)
}
},
filters: {
timeFilter(time) {
return parseTime(time, '{y}-{m}-{d}')
},
setMaxNum(val){
return val > 99 ? '99+' : val
}
},
created() {
this._getLists()
},
methods: {
...mapMutations(['setInEmailNum']),
handleTabChange(val) {
this.checkedLists = []
this.publishInfo = []
this.allChecked = false
this.openItemId = null
this.pageSize = this.step - 0
this.$store.commit('updateLoadingStatus', { isLoading: true })
this._getLists()
},

_getLists() {
const UUID = this.UUID === '' ? this.$Cookies.get('UUID') : this.$store.state.UUID
commonApi.VIP.getMsgSiteList({ UUID, pageNo: this.pageNo, pageSize: this.pageSize, read: this.currentValue }).then(data => {
const { list, total } = data
this.total = total
this.publishInfo = list
if (this.finish) this.finish()
if (this.currentValue === 0) this.setInEmailNum(total)
this.$store.commit('updateLoadingStatus', { isLoading: false })
}).catch(err => {
this.publishInfo = []
if (this.finish) this.finish()
if (this.currentValue === 0) this.setInEmailNum(0)
this.$store.commit('updateLoadingStatus', { isLoading: false })
})
},


selectedItem(id, $event) {
this.$nextTick(() => {
this.allChecked = this.checkedLists.length === this.total
})
return false
if ($event.target.tagName == 'INPUT') return
},

checkedAll() { // 选中所有
this.$nextTick(() => {
this.checkedLists = this.allChecked ? Array.from(this.publishInfo,({id}) => id) : []
})
},

openItem({ id, isRead }) { // 展开收起选择
if (!this.openItemId) {
this.openItemId = id
if (isRead) return
this._setRead(id)
} else {
if (this.openItemId === id) {
this.openItemId = null
} else {
this.openItemId = id
this._setRead(id)
}
}
},

_setRead(id) { // 设为已读
commonApi.VIP.updateMsgSite(id).then(data => {
const $index = this.publishInfo.findIndex(item => (item.id === id))
this.$set(this.publishInfo[$index], 'isRead', true)
let n = this.inEmailNum - 0
this.setInEmailNum(n - 1)
}).catch(err => {})
},

_refresh({ finish }) { // 刷新
this.finish = finish
this.pageSize = this.step - 0
this._getLists()
},

_loadmore({ finish }) { // 加载更多
this.finish = finish
if (this.publishInfo.length === this.total) {
this.$vux.toast.show({ text: this.$t('others').noData1, type: 'cancel' });
this.finish()
return
}
this.pageSize += this.step
this._getLists()
},

deleteSelected() { // 删除数据
if(this.checkedLists.length === 0){
this.$vux.toast.show({ text: this.$t('mine').stationLetter.deleteSelect, type: 'cancel' });
return
}
let ids = this.checkedLists.join(',')
commonApi.VIP.deleteMsgSite({ UUID: this.UUID, ids }).then(data => {
this.$vux.toast.show({ text: this.$t('mine').stationLetter.deleteSuccess, type: 'success'});
this.checkedLists = []
this._getLists()
}).catch(err => {
this.$vux.toast.show({ text: err,type: 'cancel', });
})
},

delItem(id) { // 删除单个数据
commonApi.VIP.deleteMsgSite({ UUID: this.UUID, ids: id }).then(data => {
this.$vux.toast.show({ text: this.$t('mine').stationLetter.deleteSuccess,type: 'text'});
this.openItemId = null
if (this.checkedLists.includes(id)) this.checkedLists.splice(this.checkedLists.findIndex((item) => (item === id)), 1)
this._getLists()
}).catch(err => {
this.$vux.toast.show({ text: err,type: 'cancel'});
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/StationLetter/myMessage.vue